import React from 'react'
import { Stack, useTheme } from '@mui/material'
import { boxStyles } from './style'
import { useCommentsByOrgId } from '../../api/aws/comments/useCommentsByOrgId'
import { useTasksByOrgId } from '../../api/aws/tasks/useTasksByOrgId'
import RenderDeleteItems from './RenderDeleteItems'

const getCounts = (comments = []) => {
  const commentCount = comments.length

  const attachmentCount = comments.reduce((total, comment) => {
    if (Array.isArray(comment.attachments)) {
      return total + comment.attachments.length
    }
    return total
  }, 0)

  return { commentCount, attachmentCount }
}

const RenderMassData = ({ task, context }) => {
  const theme = useTheme()
  const { data: allOrgTasks = [] } = useTasksByOrgId(task?.orgId || '', { isMarketing: true })
  const { data: comments = {} } = useCommentsByOrgId(task?.orgId)
  const isParent = !task.SK?.startsWith('SUBTASK_')
  const subtaskMap = allOrgTasks
    .filter(t => t.SK?.startsWith('SUBTASK_'))
    .reduce((acc, sub) => {
      const parentSK = sub.GSI1PK
      if (!acc[parentSK]) acc[parentSK] = []
      acc[parentSK].push(sub)
      return acc
    }, {})

  const subtasks = isParent ? subtaskMap[task.SK] || [] : []
  const parentComments = comments?.taskComments?.[task.SK] || []
  const { commentCount, attachmentCount } = getCounts(parentComments)
  return (
    <Stack sx={{ ...boxStyles(theme), pl: 2 }}>
      {/* Parent Task */}
      <RenderDeleteItems
        task={task}
        isSubtask={false}
        context={context}
        taskComments={parentComments}
        counts={{ commentCount, attachmentCount }}
      />

      {/* Subtasks */}
      <Stack spacing={1} pl={4}>
        {subtasks.map(sub => {
          const subComments = comments?.taskComments?.[sub.SK] || []
          return (
            <RenderDeleteItems
              key={sub.SK}
              task={sub}
              isSubtask={sub?.SK?.startsWith('SUBTASK_')}
              context={context}
              taskComments={subComments}
            />
          )
        })}
      </Stack>
    </Stack>
  )
}

export default RenderMassData
